var util = require('widgets-util');

var InGo = require('./ingo-global');
InGo._jstags = InGo._jstags || [];

var expectedScriptNameRegEx = /\/ingo\.loader\.widget\.js/i;

/**
 * Return next not used <script> for this script tag attached to dom
 */
function getNextScriptTag() {
  var tags = document.getElementsByTagName('script');

  for(var i = 0; i < tags.length; i++) {
    var tag = tags[i];

    if(!tag.src.match(expectedScriptNameRegEx) ||
      util.indexOf(InGo._jstags, tag) >= 0) {
      continue;
    }

    InGo._jstags.push(tag);
    return tag;
  }
}

module.exports.expectedScriptNameRegEx = expectedScriptNameRegEx;
module.exports.getNextScriptTag = getNextScriptTag;

/**
 * Converts string to be camel case
 * @param {string} str
 * @example
 * toCamelCase('abc_abc');//returns abcAbc
 * toCamelCase('abc-abc');//returns abcAbc
 * toCamelCase('abc.abc');//returns abcAbc
 */
function toCamelCase(str) {
  return String(str || '')
    .replace(/(?:[\-\_\.])(\w)/g, function(_, c) {
      return c ? c.toUpperCase() : '';
    });
}

function guessValueFromString(value) {
  return value === 'true' ? true :
           value === 'false' ? false :
           value.match(/^[1-9][0-9]+$/) ? parseInt(value, 10) :
           value.match(/^[0-9]+\.[0-9]+$/) ? parseFloat(value) : value;
}

// Update or create new object with the given property,
// name can be a simple property name or a path of properties separated by dots,
// in such case all required intermediate object containers will be crated automatically.
function setDeepProperty(obj, name, value) {
  obj = obj || {};

  if(!name) {
    return obj;
  }

  name = name.split('.');
  var v = obj, n;
  for(var i = 0; i < name.length - 1; i++) {
      n = toCamelCase(name[i]);
      if(typeof v[n] === 'undefined') {
        v[n] = {};
      }
      v = v[n];
  }
  n = toCamelCase(name[name.length - 1]);
  v[n] = guessValueFromString(value);
}

function getIngoAttributes(tag) {
  if(!tag) {
    return {};
  }

  // Collect all attributes passed in the script tag
  var options = {};
  for(var i = 0, l = tag.attributes.length; i < l; i++) {//tag.attributes is not an array
    var attr = tag.attributes[i];
    if(attr.name.substr(0, 10) === 'data-ingo-') {
      setDeepProperty(options, attr.name.substr(10), attr.value);
    }
  }

  return options;
}

module.exports.getIngoAttributes = getIngoAttributes;

function normalizeAttributeOptions(tag, options) {
  // Replace the base url for other widgets with the origin host,
  // it is always absolute even if we are testing it locally
  var d = tag.src.match(/^(https?:\/\/|\/\/)/i);
  if(d) {
    options.href = tag.src.split('/').slice(0, -1).join('/') + '/';//take eveything but not filename
    options.host = '//' + tag.src.replace(d[1], '').split('/')[0];
  }

  // In the same origin mode take all files from the same server including the API calls
  if(options.sameOrigin) {
    options.baseUrl = options.ingoBaseUrl = options.host;
  }

  // Try to determine page language/locale
  if(!options.lang) {
    var html = document.querySelector('html');
    if(html && html.lang) {
      options.langId = html.lang;
    }

    if(!options.langId) {
      var meta = document.querySelector('meta[name=lang], meta[name=language], meta[itemprop=lang], meta[itemprop=language]');
      if(meta && meta.content) {
        options.langId = meta.content;
      }
    }
  }

  // Set widget type if no id is given or use default type,
  // support widget type in the form of data-ingo-login, data-ingo-social
  if(!options.type && !options.id) {
    util.forEach(['login', 'social', 'registration', 'confirmation'], function(t) {
      if(typeof options[t] !== 'undefined') {
        options.type = t;
        return false;
      }
    });
  }

  return options;
}

module.exports.normalizeAttributeOptions = normalizeAttributeOptions;

function runTag(ingoWidget) {
  var tag = getNextScriptTag();

  if(!tag) {
    return;
  }

  var options = normalizeAttributeOptions(tag, getIngoAttributes(tag));

  if(!options) {
    return;
  }

  // Only instantiate if we have id or type,
  // otherwise just keep it loaded to be used directly from scripts
  if(!options.id && !options.type) {
    return;
  }

  if(options.target) {
    ingoWidget.call(document.querySelectorAll(options.target), options);

    return;
  }

  //if we does not injected before
  if(!options.target) {
    var el;
    if (options.button) {
      el = document.createElement('button');
      el.appendChild(document.createTextNode(options.button));
    } else {
      el = document.createElement('div');
    }

    tag.parentNode.insertBefore(el, tag);
    ingoWidget.call(el, options);
  }
}

module.exports.runTag = runTag;
